import React, { useContext, useEffect, useMemo, useState } from "react";
import { DonutChart, DonutChartItem } from "react-charts";
import { sleep } from "simple-utils";
import { Loading } from "../components/Loading";
import { Modal } from "../components/Modal";
import { bigNumber, formatMoney } from "../utils/money-utils";
import { stateName } from "../utils/state-utils";
import { ProcedureLabel, ProcedureType, Prop, props, propsLabel } from "./procedure-models";
import { ProcedureContext } from "./procedure-store";




function Chart(){
    const {state:{selected}} = useContext(ProcedureContext)
    const [prop, setProp] = useState<Prop>(null)
    

    function baseTooltip(item:DonutChartItem){
        return <>
            <b>{item.label}</b><br/> 
            {prop == 'spend' ? formatMoney(item.value) : bigNumber(item.value)}
        </>
    }

    const series:DonutChartItem[] = useMemo(() => {
        if(prop == null) return null;
        var a = Object.entries(selected.info).map(([k, v], i):DonutChartItem =>{
            const type = k as ProcedureType
            if(k == 't') return null;
            return {
                label: ProcedureLabel[type],
                style: `color1`,
                value: v?.[prop] || 0
            }
        })
        a = a.filter(c => c != null && c.value > 0);
        a.sort((t1, t2) => t2.value - t1.value)
        a.forEach((c, i)=> c.style = `color${i+1}`)
        return a;
    }, [selected, prop])

    useEffect(()=>{
        sleep(600).then(() => setProp("leads"))   
    }, [])

    return <>
        <select className="form-select" value={prop || ""} onChange={(e)=>setProp(e.target.value as Prop)}>
            {props.map(p => <option value={p}>{propsLabel[p]}</option>)}
        </select>
        { prop != null && <DonutChart className="donut-center" key={prop} data={series} height={300} width={300} 
            radius={100} thickness={40}
            createTooltip={baseTooltip}
            />}
        { prop == null && <Loading className="my-4" /> }
    </>
}


export function ProcedureChartModal(){
    const {state:{selected}, dispatch} = useContext(ProcedureContext)
    if(!selected) return null;

    return <Modal title={selected.name} onHide={() => dispatch({type:'select', selected: null})}>
        <Chart />
    </Modal>
}